import script from "./SpendingPotButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpendingPotButton.vue?vue&type=script&setup=true&lang=ts"

import "./SpendingPotButton.vue?vue&type=style&index=0&id=52a95f4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a95f4f"]])

export default __exports__